
<div class="table-content-component-panel-monitoreo" style="position: relative;">

  <ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" name="loadingPlatformAlertsSpinner" size = "medium" color = "#fff" type = "ball-pulse" [fullScreen] = "false"><p style="color: white" > {{ 'DRIVERS.MESSAGE.LOADING_DRIVERS' | translate }} </p></ngx-spinner>


  <div class="d-flex flex-column gap-2" style="
        padding-left: 20px;
        padding-right: 10px;
    ">
    <div style="padding: 0 !important;" id="rowBusqueda">
      <div class="d-flex" style="height: 38px;">
        <div class="d-flex flex-grow-1">
          <span class="p-input-icon-right flex-grow-1 me-2">
            <i class="fa fa-search" aria-hidden="true"></i>
            <input (ngModelChange)="onSearchDriverDebounced($event)" [(ngModel)]="searchValueDriver" type="text" id="searchKey" class="form-control ng-pristine ng-untouched ng-valid ng-empty" aria-invalid="false" [placeholder]="'DRIVERS.SEARCH.GENERAL' | translate" />
          </span>
        </div>
        <ng-container *ngIf="driversService.configuration.addDriver">
          <button *appHasPermission="'drivers_create'" (click)="clickAgregarDriver()" type="button" class="btn-gl-blue btn-circle btn-dark-hover flex-none me-2" [title]="'DRIVERS.ACTION.ADD_DRIVER' | translate" data-bs-toggle="tooltip" data-bs-placement="auto" container="body" onclick="this.blur();">
            <i class="fa fa-plus" aria-hidden="true"></i>
          </button>
        </ng-container>
  
        <ng-container *ngIf="driversService.configuration.enrollmentDriver">
          <div *appHasPermission="['drivers_enrollment_cipia']" ngbDropdown container="body" placement="right-top left-top" class="flex-none">
            <button class="btn-gl-blue btn-dark-hover btn-circle" ngbDropdownToggle>
              <i class="fas fa-fw fa-bars fa-1" aria-hidden="true"></i>
            </button>
            <div ngbDropdownMenu class="gl-custom-dropdown dropdown-alert-panel">
              <div *appHasPermission="'drivers_enrollment_cipia'" ngbDropdownItem (click)="openEnrollmentModal()">
                <span>{{ 'DRIVERS.LABELS.CIPIA_ENROLLMENT' | translate }}</span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  
    <!-- TABLA -->
    <div class="" style="flex-grow: 0;">
      <p-table 
       [value]="driversService.tblDataDriver"
        styleClass="p-datatable-sm"
        [scrollable]="true" 
        scrollHeight="calc(100vh - 90px - calc(calc(calc(var(--navbar-height) + var(--row-busqueda-height)) + calc(var(--pm-vehiculos-header-height) + var(--treetable-header-height)))))"
        [virtualScroll]="true"
        [rows]="20"
      > 
        <ng-template pTemplate="header">
          <tr>
            <th style="width: 10%;" class="text-center"
                pSortableColumn="index"
                pTooltip="Número de registro"
                *ngIf="driversService.configuration.tableColumns.index"
                tooltipPosition="top">
              N.º
            </th>
  
            <th style="width: 40%;" class="text-start"
                pSortableColumn="nombre"
                pTooltip="Nombre del conductor"
                *ngIf="driversService.configuration.tableColumns.name"
                tooltipPosition="top">
              {{ 'FIELDS.NAME' | translate }}
            </th>
  
            <th style="width: 35%;" class="text-center"
                pSortableColumn="identification"
                pTooltip="Tipo de identificación"
                *ngIf="driversService.configuration.tableColumns.indentificate"
                tooltipPosition="top">
              {{ 'FIELDS.IDENTIFICATION' | translate }}
            </th>
  
            <th style="width: 15%;" class="text-center"
                pSortableColumn="cofig"
                pTooltip="Opciones de configuración"
                *ngIf="driversService.configuration.tableColumns.edit"
                tooltipPosition="top">
              <i class="fa fa-cog fa-lg"></i>
            </th>
          </tr>
        </ng-template>
  
        <ng-template pTemplate="body" let-driver let-i="rowIndex">
          <tr>
            <td style="width: 10%;"
              *ngIf="driversService.configuration.tableColumns.index"
             class="text-center">{{ i + 1 }}</td>
            <td 
              *ngIf="driversService.configuration.tableColumns.name"
              style="width: 40%;">{{ driver.nombre_conductor }}</td>
            <td 
              *ngIf="driversService.configuration.tableColumns.indentificate"
            style="width: 35%;">
              <div class="d-flex justify-content-center">
                <div class="p-2" *ngIf="driver.tipo_identificacion.vehicle">
                  <i class="fas fa-car" style="font-size: 1rem"
                    [pTooltip]="'DRIVERS.TOOLTIPS.BY_VEHICLE' | translate"
                    tooltipPosition="top"></i>
                </div>
                <div class="p-2" *ngIf="driver.tipo_identificacion.icipia">
                  <svg
                    width="16"
                    height="16"
                    fill="currentColor"
                    viewBox="0 0 16 16"
                    [pTooltip]="'DRIVERS.TOOLTIPS.BY_CIPIA_CODE' | translate"
                    tooltipPosition="top"
                    style="vertical-align: middle; cursor: pointer;"
                  >
                    <path
                      d="M4.5 5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M3 4.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0"
                    />
                    <path
                      d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2H8.5v3a1.5 1.5 0 0 1 1.5 1.5h5.5a.5.5 0 0 1 0 1H10A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5H.5a.5.5 0 0 1 0-1H6A1.5 1.5 0 0 1 7.5 10V7H2a2 2 0 0 1-2-2zm1 0v1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H2a1 1 0 0 0-1 1m6 7.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5"
                    />
                  </svg>
                </div>
                <div class="p-2" *ngIf="driver.tipo_identificacion.ibutton">
                  <i class="fas fa-key" style="font-size: 1rem"
                    [pTooltip]="'DRIVERS.TOOLTIPS.BY_IBUTTON_KEY' | translate"
                    tooltipPosition="top"></i>
                </div>
              </div>
            </td>
            <td style="width: 15%;"
              *ngIf="driversService.configuration.tableColumns.edit"
              class="text-center">
              <div *appHasPermission="['drivers_update', 'drivers_delete']" ngbDropdown container="body" class="d-flex justify-content-center align-items-center edit-column" [autoClose]="true" placement="right-top right-bottom left-top left-bottom">
    
                <i class="fa fa-cog" ngbDropdownToggle></i>
                <div ngbDropdownMenu class="gl-custom-dropdown geofences-table-dropdown">
                  <div *appHasPermission="'drivers_update'" ngbDropdownItem (click)="clickConfigurarDriver(driver.id)" ><i class="fa fa-pencil-square-o" aria-hidden="true"></i> {{ 'GENERAL.CONFIGURE' | translate }}</div>
                  <ng-container *ngIf="driver.tipo_identificacion.icipia">
                    <div *appHasPermission="'drivers_show_imagen'" ngbDropdownItem (click)="clickShowDriverImagen(driver)" ><i class="fa fa-image" aria-hidden="true"></i> Ver imagen</div>
                  </ng-container>
                  <div *appHasPermission="'drivers_delete'" ngbDropdownItem (click)="clickEliminarDriver(driver.id)" ><i class="fa fa-trash-o" aria-hidden="true"></i> {{ 'GENERAL.DELETE' | translate }}</div>
                </div>
              </div>
            </td>
          </tr>
        </ng-template>
  
  
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center">{{ 'DRIVERS.MESSAGE.NO_DRIVERS_ASSIGNED' | translate }}</td>
          </tr>
        </ng-template>
      </p-table>
  
    </div>
  </div>

  <!-- 
  <div *appHasPermission="'drivers_create'" class="d-flex justify-content-center my-4 panel-izq-container-footer">
    <div class="col-6">
        <button type="button" (click)="clickAgregarDriver()" class="btn-gl-save btn-dark-hover w-100" >{{ 'DRIVERS.ACTION.ADD_DRIVER' | translate }}</button>
    </div>
  </div> -->
  <div *ngIf="(driversService.modalActive)">
    <app-drivers-modal></app-drivers-modal>
  </div>

  <div *ngIf="(driversService.modalProgramacionActive)">
    <app-drivers-programacion-modal></app-drivers-programacion-modal>
  </div>

  <div *ngIf="(driversService.modalProgrammingActive)">
   <app-drivers-programming-modal></app-drivers-programming-modal>
  </div>

  <div *ngIf="(driversService.modalEnrollmentActive)">
    <app-driver-enrollment-modal></app-driver-enrollment-modal>
   </div>


</div>

<p-dialog
  [header]="'Conductor - ' + (driverCipia?.nombre_conductor || '')"
  [(visible)]="displayDriverImagen"
  [modal]="true"
  [baseZIndex]="1000"
  [dismissableMask]="true"
  [contentStyle]="{ padding: '0' }"
  (onHide)="closeShowDriverImagen()"
>
  <div class="image-container">
    <ng-container *ngIf="!imageError; else errorTpl">
      <img
        *ngIf="driverCipia?.nro_cipia"
        [src]="imagenUrl + driverCipia.nro_cipia"
        alt="Imagen del conductor"
        class="driver-image"
        (error)="onImageError()"
      />
    </ng-container>

    <ng-template #errorTpl>
      <div class="image-error">
        <i class="pi pi-exclamation-triangle"></i>
        <p>No se pudo cargar la imagen del conductor</p>
      </div>
    </ng-template>
  </div>
</p-dialog>
